import { useGetRegions, usePermissions } from '@dispatch/shared/hooks';
import { useCurrentUser } from '@dispatch/web/auth';
import { Regions } from '@dispatch/web/features/regions';
import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

const RegionsPage = () => {
  const location = useLocation();
  const { tenantId } = useCurrentUser();
  const {
    data: regions,
    status,
    refetch,
  } = useGetRegions({ tenantId: tenantId || '' });

  const { permissions } = usePermissions();

  useEffect(() => {
    refetch && refetch();
  }, [location.pathname, refetch]);

  return (
    <>
      <Regions rows={regions?.data} status={status} permissions={permissions} />
      <Outlet />
    </>
  );
};

export default RegionsPage;
